<template>
  <div>
    <register-alianza
      ref="register"
      @refresh="refreshConfigs"
    />

    <div class="mt-6">
      <show-alianzas
        ref="table"
        @stores="openStores"
        @editar="editarConfiguracion"
      />
    </div>

    <show-alianza-stores
      v-model="dialogStores"
      :config="selectedConfig"
    />
  </div>
</template>

<script>

  export default {

    components: {

      RegisterAlianza: () =>
        import('./components/RegisterAlianza'),

      ShowAlianzas: () =>
        import('./components/ShowAlianzas'),

      ShowAlianzaStores: () =>
        import('./components/ShowAlianzaStores'),

    },

    data () {
      return {

        dialogStores: false,

        selectedConfig: {},

      }
    },

    methods: {

      refreshConfigs () {
        this.$refs.table.load()
      },

      openStores (item) {
        this.selectedConfig = item

        this.dialogStores = true
      },

      editarConfiguracion (item) {
        this.$refs.register.load(item)
      },

    },

  }

</script>
